import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShip, faUmbrellaBeach, faGift } from '@fortawesome/free-solid-svg-icons';
import { getLandingIMessageHref, LANDING_CTA_TEXT } from './LandingConstants';

const EXPERIENCE_CARDS = [
  {
    number: 1,
    title: 'Wide Selection of Boats & Yachts',
    description: (
      <>
        We work with a diverse fleet of boats and yachts in Miami, <strong>offering options for every budget.</strong> Tell us what you're looking for, and we'll match you with the best available boat for your day on the water.
      </>
    ),
    icon: faShip,
  },
  {
    number: 2,
    title: 'Iconic Miami Experiences',
    description: (
      <>
        Island hopping, sandbar parties, celebrity home tours, sunset cruises, or pure relaxation — <strong>we tailor the experience to your vibe.</strong> Every charter comes with stunning views, premium sound, floating mats, and unforgettable moments.
      </>
    ),
    icon: faUmbrellaBeach,
  },
  {
    number: 3,
    title: 'Easy Booking + Exclusive Perks',
    description: (
      <>
        Book effortlessly via WhatsApp or iMessage and get access to special perks, <strong>including FREE Jet Ski on select charters</strong>, weekday specials (Mon–Thu), and seamless departures from Miami's top marinas.
      </>
    ),
    icon: faGift,
  },
];

const LandingFeaturesSection = () => {
  return (
    <section className="landing-features">
      <div className="landing-features__title-bar">
        <h2 className="landing-features__title">What's included in your experience</h2>
      </div>
      <div className="landing-features__inner">
        <div className="landing-features__cards">
          {EXPERIENCE_CARDS.map((card) => (
            <article key={card.number} className="landing-features__card">
              <h3 className="landing-features__card-title">
                #{card.number}: {card.title}
              </h3>
              <div className="landing-features__card-icon-wrapper">
                <FontAwesomeIcon icon={card.icon} className="landing-features__card-icon" />
              </div>
              <p className="landing-features__card-desc">{card.description}</p>
            </article>
          ))}
        </div>
        <div className="landing-features__cta-wrapper">
          <a
            href={getLandingIMessageHref()}
            className="landing-hero__cta"
            rel="noopener noreferrer"
          >
            {LANDING_CTA_TEXT}
          </a>
        </div>
      </div>
    </section>
  );
};

export default LandingFeaturesSection;
